const HEX_COLOR = /^#[0-9a-f]{6}$/i;
export const isHexColor = (value) => typeof value === 'string' && HEX_COLOR.test(value);
const channel = (hex, offset) => {
    const c = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
};
export function relativeLuminance(hex) {
    if (!isHexColor(hex))
        throw new Error(`Not a #RRGGBB colour: ${String(hex)}`);
    return 0.2126 * channel(hex, 1) + 0.7152 * channel(hex, 3) + 0.0722 * channel(hex, 5);
}
export function contrastRatio(a, b) {
    const la = relativeLuminance(a);
    const lb = relativeLuminance(b);
    const [light, dark] = la >= lb ? [la, lb] : [lb, la];
    return (light + 0.05) / (dark + 0.05);
}
export const WCAG_AA_TEXT = 4.5;
export const WCAG_AA_LARGE_TEXT = 3;
export const WCAG_NON_TEXT = 3;
export function meetsContrastAA(foreground, background, largeText = false) {
    return contrastRatio(foreground, background) >= (largeText ? WCAG_AA_LARGE_TEXT : WCAG_AA_TEXT);
}
const byte = (value) => Math.round(Math.min(255, Math.max(0, value)))
    .toString(16)
    .padStart(2, '0')
    .toUpperCase();
export function blendHex(foreground, background, opacity) {
    if (!isHexColor(foreground) || !isHexColor(background)) {
        throw new Error(`Not a #RRGGBB colour: ${String(isHexColor(foreground) ? background : foreground)}`);
    }
    const alpha = Math.min(1, Math.max(0, opacity));
    const mix = (offset) => byte(parseInt(foreground.slice(offset, offset + 2), 16) * alpha +
        parseInt(background.slice(offset, offset + 2), 16) * (1 - alpha));
    return `#${mix(1)}${mix(3)}${mix(5)}`;
}
export function ensureContrast(foreground, background, ratio) {
    if (contrastRatio(foreground, background) >= ratio)
        return foreground;
    const lighter = relativeLuminance(foreground) >= relativeLuminance(background);
    const nearExtreme = lighter ? '#FFFFFF' : '#000000';
    const farExtreme = lighter ? '#000000' : '#FFFFFF';
    const reaches = (colour) => contrastRatio(colour, background) >= ratio;
    const extreme = reaches(nearExtreme) ? nearExtreme : reaches(farExtreme) ? farExtreme : undefined;
    if (!extreme) {
        return contrastRatio(nearExtreme, background) >= contrastRatio(farExtreme, background) ? nearExtreme : farExtreme;
    }
    let low = 0;
    let high = 1;
    for (let i = 0; i < 24; i++) {
        const middle = (low + high) / 2;
        if (reaches(blendHex(extreme, foreground, middle)))
            high = middle;
        else
            low = middle;
    }
    return blendHex(extreme, foreground, high);
}
//# sourceMappingURL=color-contrast.utils.js.map